module.exports = __webpack_public_path__ + "static/media/microscope.9fd1851d.svg";